export class CreateContactTypeModel {
  public descricao: string = ''
}

export class EditContactTypeModel {
  public id: number = 0
  public descricao: string = ''
}

export class DeleteContactTypeModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchContactTypeModel {
  public descricao: string = ''
}

export class CreateContactTypeResponse {
  public response: any
}
export class EditContactTypeResponse {
  public response: any
}
export class DeleteContactTypeResponse {
  public response: any
}
export class PagedContactTypeResponse {
  public response: any
}
